export const setVersions = (versions) => ({
  type: 'SET_VERSIONS',
  payload: versions
})

export const setKeyframeToEnd = (times_) => ({
  type: 'SET_KEYFRAME_TO_END',
  payload: times_.length - 1
})

export const setKeyframeToBegin = () => ({
  type: 'SET_KEYFRAME_TO_BEGIN',
  payload: 0
})

export const toogleAnimationVisible = (display) => ({
  type: 'TOOGLE_ANIMATION_VISIBLE',
  payload: display
})

export const setKeyframeTo = (version) => ({
  type: 'SET_KEYFRAME_TO',
  payload: version
})

export const setSceneLoaded = () => ({
  type: 'SCENE_LOADED',
  payload: true
})
